import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from '@/utils/store.js'
import { Button,Cell,CellGroup,Toast,Image,Form,Field,Slider,Col, Row,Tab, Tabs,Swipe, SwipeItem,Lazyload,List} from 'vant';
import 'vant/lib/index.css'
import './assets/style/common.css'
import request from "@/utils/request"
Vue.config.productionTip = false
Vue.use(Button)
Vue.use(Cell)
Vue.use(CellGroup)
Vue.use(Toast)
Vue.use(Image)
Vue.use(Form)
Vue.use(Field)
Vue.use(Slider)
Vue.use(Col)
Vue.use(Row)
Vue.use(Tab)
Vue.use(Tabs)
Vue.use(Swipe)
Vue.use(SwipeItem)
Vue.use(Lazyload);
Vue.use(List)

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
